import { api } from './client'

const API_BASE = import.meta.env.VITE_API_URL || ''

// Admin user type (different from tenant User -- includes platform admin info)
export interface AdminUser {
  id: string
  email: string
  name: string
  is_platform_admin: true
  permissions: string[]
}

// Reuse tenant auth types for OTP flow
export interface RequestOtpResponse {
  message: string
}

export interface VerifyOtpResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
  user: {
    id: string
    email: string
    name: string
    role: string
    firm_id: string
  }
}

export interface RefreshResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
}

export const adminAuthApi = {
  // Admin-specific OTP endpoint -- checks platform-admin role before sending OTP
  requestOtp: (email: string): Promise<RequestOtpResponse> =>
    api.post('/api/v1/auth/admin/request-otp', { email }),

  verifyOtp: (email: string, otp: string): Promise<VerifyOtpResponse> =>
    api.post('/api/v1/auth/verify-otp', { email, otp }),

  // Admin-specific: verify platform admin role via RBAC
  getAdminMe: (): Promise<AdminUser> =>
    api.get('/api/v1/admin/platform/me'),

  // Refresh -- raw fetch to avoid 401 loop (same pattern as tenant PWA)
  refreshToken: async (refreshToken: string): Promise<RefreshResponse> => {
    const response = await fetch(`${API_BASE}/api/v1/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken }),
    })
    if (!response.ok) throw new Error(`Refresh failed: ${response.status}`)
    return response.json()
  },

  // Best-effort server logout (same pattern as tenant PWA)
  logoutServer: async (
    accessToken: string,
    refreshToken: string
  ): Promise<void> => {
    try {
      await fetch(`${API_BASE}/api/v1/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
      })
    } catch {
      // Best-effort
    }
  },
}
